"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _Modal = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Modal"));
var _ModalHeader = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalHeader"));
var _ModalBody = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalBody"));
var _ModalFooter = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalFooter"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _modals = require("../../../utils/modals");
var _AssetsTable = _interopRequireDefault(require("../../AssetsTable"));
var _events = require("../../../analytics/events");
var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 9a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1zm0 6.014a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.276 3.959c.773-1.315 2.675-1.315 3.448 0l8.251 14.027C22.76 19.32 21.798 21 20.252 21H3.748c-1.546 0-2.508-1.68-1.723-3.014L10.276 3.96zM12 4.973 3.748 19h16.504L12 4.973z"
  }));
};
WarningIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "modal": "DisallowedPromotionModal__modal__KCoaX",
  "header": "DisallowedPromotionModal__header__mUx0O",
  "body": "DisallowedPromotionModal__body__1krtH",
  "footer": "DisallowedPromotionModal__footer__vngNq",
  "title": "DisallowedPromotionModal__title__183x0",
  "body-content": "DisallowedPromotionModal__body-content__36LtA",
  "bodyContent": "DisallowedPromotionModal__body-content__36LtA",
  "icon": "DisallowedPromotionModal__icon__zlOXV",
  "modal-lg": "DisallowedPromotionModal__modal-lg__b-htJ",
  "modalLg": "DisallowedPromotionModal__modal-lg__b-htJ"
}; 
require('./DisallowedPromotionModal.css');
var DisallowedPromotionModal = function DisallowedPromotionModal(_ref) {
  var dependencies = _ref.dependencies;
  var _useModals = (0, _exchangeReactHooks.useModals)(),
    closeModal = _useModals.closeModal;
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var labelId = 'version-info-modal-title';
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    renderInBody: false,
    onEsc: function onEsc() {
      return closeModal();
    },
    onClickOverlay: function onClickOverlay() {
      return closeModal();
    },
    className: (0, _classnames.default)(styles.modal, styles.modalLg),
    ariaLabelledBy: labelId,
    role: "alertdialog"
  }, /*#__PURE__*/_react.default.createElement(_ModalHeader.default, {
    className: styles.header,
    testId: "modal-header"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: styles.title
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.icon,
    size: "s"
  }, /*#__PURE__*/_react.default.createElement(WarningIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
    className: styles.text,
    "data-test-id": "disallowed-promotion-title",
    id: labelId
  }, "Unable to promote - Dependent assets"))), /*#__PURE__*/_react.default.createElement(_ModalBody.default, {
    testId: "modal-body",
    className: styles.body
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: styles.disclaimer
  }, "This version has dependencies in ", /*#__PURE__*/_react.default.createElement("strong", null, "Development"), " and cannot be promoted to ", /*#__PURE__*/_react.default.createElement("strong", null, "Stable"), ". Promote the dependencies to fix this issue."), /*#__PURE__*/_react.default.createElement(_AssetsTable.default, {
    onAssetClick: function onAssetClick() {
      return trackEvent(_events.EVENT_TYPES.ASSET_DEPENDENCY_CLICKED);
    },
    assets: dependencies,
    title: "Dependent assets",
    caption: "Assets dependencies",
    testId: "asset-dependencies"
  })), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, {
    testId: "modal-footer",
    className: styles.footer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    testId: "close-button",
    kind: "tertiary",
    onClick: function onClick() {
      return closeModal();
    },
    noFill: true
  }, "Close")));
};
var DisallowedPromotionModalContainer = (0, _modals.setModalName)('DisallowedPromotionModal')(DisallowedPromotionModal);
var _default = exports.default = DisallowedPromotionModalContainer;
//# sourceMappingURL=DisallowedPromotionModal.js.map